<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn :to="'/progress/' + user.uid" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">{{progress.name + ' for ' + user.displayName}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else class="py-3 px-2" row wrap justify-center>
        <v-flex v-if="tableOfContents.length == 0" class="py-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            Empty Course
          </div>
        </v-flex>
        <v-flex v-else class="px-2 pb-3" xs12 md10>
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-content class="mb-3" v-for="c, i in tableOfContents" :key="i">
              <div slot="header">
                <div class="title secondary--text">
                  <span><b>{{c.name}}</b></span>
                </div>
              </div>
              <v-card>
                <v-layout row wrap>
                  <v-flex class="pb-2 pl-4" xs12>
                    <v-list class="pt-0">
                      <v-list-tile
                        v-for="s, j in c.sections"
                        :key="j"
                        @click=""
                        :to="'/progress/' + user.uid + '/' + progress.key + '/' + s.key"
                        ripple>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <span>{{s.name}} </span>
                            <span><b>&nbsp;&nbsp;[{{s.completeTasks + '/' + s.totalTasks}}]</b></span>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    user: {},
    progress: {},
    tableOfContents: []
  }),
  computed: {
    now () {
      return this.$store.getters.now
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    beforeEnter () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (!this.$store.getters.userById(this.$route.params.uid)) {
        appMsg.msg = 'Student not found'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$route.push('/progress')
      }
      if (!this.$store.getters.progressByKey(this.$route.params.progressKey)) {
        appMsg.msg = 'Course progress not found'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$route.push('/progress')
      }
    },
    load () {
      this.loading = true
      this.beforeEnter()
      this.user = this.$store.getters.userById(this.$route.params.uid)
      this.progress = this.$store.getters.progressByKey(this.$route.params.progressKey)
      const course = this.$store.getters.courseByKey(this.progress.courseKey)
      let entry = null
      let content = null
      if (course.content) {
        for (let contentKey of course.content) {
          content = this.$store.getters.contentByKey(contentKey)
          entry = {...content, sections: []}
          entry.sections = this.getSections(contentKey)
          this.tableOfContents.push(entry)
        }
      }
      this.$store.dispatch('loadTaskProgress', this.user.uid).then(() => {
        this.loading = false
      })
    },
    getSections (contentKey) {
      let s = this.$store.getters.sectionByContent(contentKey)
      let sections = []
      let entry = null
      for (let section of s) {
        entry = {
          ...section,
          completeTasks: 0,
          totalTasks: 0
        }
        this.getSectionStats(entry)
        sections.push(entry)
      }
      sections.sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
      })
      return sections
    },
    getSectionStats (section) {
      let tasks = this.$store.getters.taskBySection(section.key)
      section.totalTasks = tasks.length
      let taskProgress = null
      for (let t of tasks) {
        taskProgress = this.$store.getters.taskProgressByTaskByProgress(t.key, this.progress.key)
        if (taskProgress) {
          if (taskProgress.complete) section.completeTasks += 1
          else if (taskProgress.endTime && this.now > taskProgress.endTime) section.completeTasks += 1
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/progress/TableOfContents.vue